import { forwardRef } from "react";
import { MarkPriceIV, MiddleRow } from "./style";
import { IWSSTicker } from "../../../hooks/wss/model/ticker";
import { formatKnownPrice } from "../../../utils/unknownNumbers";

interface IMarkRowProps {
  ticker?: IWSSTicker;
}

export const MarkRow = forwardRef<any, IMarkRowProps>(({ ticker }, ref) => (
  <MiddleRow ref={ref}>
    <span>
      {ticker ? (
        <>
          {/* A ticker can arrive without a mark: "-", never "$0.00". */}
          <span>{formatKnownPrice(ticker.mark?.price)}</span>
          {ticker.mark?.greeks?.iv && (
            <MarkPriceIV>
              {(Number(ticker.mark.greeks.iv) * 100).toFixed(2)}%
            </MarkPriceIV>
          )}
        </>
      ) : (
        "---"
      )}
    </span>
  </MiddleRow>
));
